// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner_spinnerContainer__3Q4Du","Loader":"Spinner_Loader__1twK-","load2":"Spinner_load2__2gkgc"};